// The two assessments tables (scenario rows for one subject, entity rows for one area) sit in the same tab and
// are meant to read as one component, so what they share is defined once rather than kept in step by hand.
export const assessmentsTableAddButtonContainer = {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: 2,
    gap: 2,
};
